import sendSyncToExagonInventory from '@hooks/configuration/sendSyncToExagonInventory';

const usePostSyncToExagonInventory = (id) => sendSyncToExagonInventory(id);

export default usePostSyncToExagonInventory;
